import { Link, useLocation, useNavigate } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useApp } from "@/context/AppContext";
import { t } from "@/lib/i18n";

function SourceSwitcher() {
  const { sourceLang } = useApp();
  const navigate = useNavigate();
  const opts = [
    { code: "no", label: "Norsk", path: "/" },
    { code: "es", label: "Español", path: "/es" },
  ];
  return (
    <div
      data-testid="source-switcher"
      className="flex items-center rounded-full border border-gray-300 p-0.5 bg-white"
    >
      {opts.map((o) => (
        <button
          key={o.code}
          data-testid={`source-option-${o.code}`}
          onClick={() => navigate(o.path)}
          className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${
            sourceLang === o.code
              ? "bg-gray-900 text-white"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default function Header() {
  const { lang } = useApp();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <header className="sticky top-0 z-30 bg-[#F9F8F6]/85 backdrop-blur-md border-b border-gray-200/70">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif-display text-3xl font-bold tracking-tighter text-gray-900 group-hover:text-[#E85D04] transition-colors">
            I Swear
          </span>
          <span className="hidden sm:inline text-[10px] tracking-eyebrow text-gray-500">
            · NO → ES · EN · PL
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/"
            data-testid="nav-browse"
            className={`hidden sm:inline text-sm font-medium px-2 py-1 transition-colors ${
              pathname === "/" ? "text-gray-900" : "text-gray-500 hover:text-gray-900"
            }`}
          >
            {t("nav_browse", lang)}
          </Link>
          <Link
            to="/submit"
            data-testid="nav-submit"
            className={`text-sm font-medium px-2 py-1 transition-colors ${
              pathname === "/submit" ? "text-gray-900" : "text-gray-500 hover:text-gray-900"
            }`}
          >
            {t("nav_submit", lang)}
          </Link>
          {!isAdmin && (
            <Link
              to="/admin/login"
              data-testid="nav-admin"
              className="text-sm font-medium px-2 py-1 text-gray-500 hover:text-gray-900 transition-colors"
            >
              {t("nav_admin", lang)}
            </Link>
          )}
          {!isAdmin && <SourceSwitcher />}
          <LanguageSwitcher />
        </nav>
      </div>
    </header>
  );
}
